import { render } from "./AssessmentCategory.vue?vue&type=template&id=fc091804"
import script from "./AssessmentCategory.vue?vue&type=script&lang=js"
export * from "./AssessmentCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__